import {useSWRConfig} from "swr";
import {useCallback} from "react";

export function useInvalidateAllQueries() {
    const {mutate} = useSWRConfig();
    return useCallback(() => {
        return mutate((key) => true, undefined, {
            revalidate: true,
        });
    }, [mutate]);
}
